'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    swatchPickerClassNames: function() {
        return swatchPickerClassNames;
    },
    useSwatchPickerStyles_unstable: function() {
        return useSwatchPickerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const swatchPickerClassNames = {
    root: 'fui-SwatchPicker'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f14ufcw5",
        mc9l5x: "f22iagw"
    },
    row: {
        Beiy3e4: "f1063pyq"
    },
    grid: {
        Beiy3e4: "f1vx9l62"
    },
    spacingSmall: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f1t6b6ee"
    },
    spacingMedium: {
        i8kkvl: 0,
        Belr9w4: 0,
        rmohyg: "f4xv25i"
    }
}, {
    d: [
        [
            ".f14ufcw5{padding:var(--spacingHorizontalNone) var(--spacingVerticalNone);}",
            {
                p: -1
            }
        ],
        ".f22iagw{display:flex;}",
        ".f1063pyq{flex-direction:row;}",
        ".f1vx9l62{flex-direction:column;}",
        [
            ".f1t6b6ee{gap:2px;}",
            {
                p: -1
            }
        ],
        [
            ".f4xv25i{gap:4px;}",
            {
                p: -1
            }
        ]
    ]
});
const useSwatchPickerStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    const layoutStyle = state.isGrid ? styles.grid : styles.row;
    const spacingStyle = state.spacing === 'small' ? styles.spacingSmall : styles.spacingMedium;
    state.root.className = (0, _react.mergeClasses)(swatchPickerClassNames.root, styles.root, layoutStyle, spacingStyle, state.root.className);
    return state;
};
